<p-select [options]="options" [(ngModel)]="value" dataKey="alpha2" [placeholder]="placeholder"
    [disabled]="disabled" [appendTo]="appendTo" [filter]="filter" filterBy="alpha2,name" [showClear]="showClear"
    class="w-full"
    (onBlur)="emitOnBlur($event)" (onChange)="emitOnChange($event)" (onClear)="emitOnClear($event)"
    (onClick)="emitOnClick($event)" (onFilter)="emitOnFilter($event)" (onFocus)="emitOnFocus($event)"
    (onHide)="emitOnHide($event)" (onLazyLoad)="emitOnLazyLoad($event)" (onShow)="emitOnShow($event)">

    <!-- Option sélectionnée -->
    <ng-template let-country #selectedItem>
        @if (!!country) {
        <span>{{ country.flag }} {{ country.name }}</span>
        }
    </ng-template>

    <!-- Option dans la liste -->
    <ng-template let-country #item>
        <span>{{ country.flag }} {{ country.name }}</span>
    </ng-template>
</p-select>
